import * as React from "react";

export const RedoSvg = (props) => (
  <svg
    width={18}
    height={14}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.7921 13.0001H5.91988C3.20397 13.0001 0.999757 10.8702 0.999757 8.24577C0.999757 5.62139 3.20397 3.49146 5.91988 3.49146H16.7441"
      stroke={props.stroke || "#A8ABBB"}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4809 5.86842L17 3.43421L14.4809 1"
      stroke={props.stroke || "#A8ABBB"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
